module.exports = __webpack_public_path__ + "assets/img/sweetbot-webbanner.6c3d75ce.jpg";